import { useState, useEffect, useContext } from "react";

import { Card, Badge } from "react-bootstrap";

import { UserSettingsContext } from "../../../contexts/UserSettingsContext";
import authenticatedFetch from "../../../utils/fetch";
import getActivityDateTimeDisplay from "../../../utils/datetime";
import getRawDocumentCategories from "../../../utils/documentCategories";
import EditableExpires from "../../../utils/EditableExpires";

function numberToWordOrdinal(n) {
  const ordinals = [
    "", "1st", "2nd", "3rd", "4th", "5th",
    "6th", "7th", "8th", "9th", "10th"
  ];

  return ordinals[n] || `${n}th`;
}

const ReminderFeed = () => {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState([]);
  const { isH3Admin, authorities } = useContext(UserSettingsContext);
  let rawDocumentCategories = getRawDocumentCategories(isH3Admin, authorities);

  useEffect(() => {
    authenticatedFetch({
      path: "reminderlog/recentactivity/",
      successHandler: function(result) {
        setIsLoaded(true);
        setData(result);
      },
      errorHandler: function(error) {
        setIsLoaded(true);
        setError(error);
      }
    });
  }, [])

  function handleClicked(e, practiceId, providerId)
  {
    e.preventDefault();
    window.location = providerId ? "/provider/" + providerId : "/practice/" + practiceId;
  }

  function getTitle(activity)
  { 
    var title;
    
    if (activity.providerId && activity.providerFormattedName)
    {
      title = activity.providerFormattedName;
    }
    else
    {
      title = activity.practiceName;
    }

    var categoryLabel = '';
    if (activity.documentCategory)
    {
      for (let i = 0; i < rawDocumentCategories.length; i++)
      {
        if (activity.documentCategory === rawDocumentCategories[i].value)
        {
          categoryLabel = rawDocumentCategories[i].label;
          break;
        }
      }
    }

    var categoryElement = <></>;
    if (categoryLabel && categoryLabel.length > 0)
    {
      categoryElement = <><span> | </span><Badge className="bg-light text-muted">{categoryLabel}</Badge></>;
    }

    var extraElement = <></>;
    if (activity.extra && activity.extra.length > 0)
    {
      var extra = activity.extra;
      if (extra.length > 30)
      {
        extra = extra.substring(0, 28) + "...";
      }

      extraElement = <><span> | </span><Badge className="bg-light text-muted">{extra}</Badge></>;
    }

    return <>{title}{categoryElement}{extraElement}</>;
  }

  var activityList;
  if (error || !data)
  {
    activityList = <div className="d-flex">Something went wrong... please reload the page...</div>
  }
  else if (!isLoaded)
  {
    activityList = <div className="d-flex">Loading...</div>
  }
  else
  {
      activityList = data.map((activity, i) => {
      var documentFilename = activity.documentFilename;
      if (documentFilename && documentFilename.length > 45)
      {
        documentFilename = documentFilename.substring(0, 43) + "...";
      }
      
      var expirationElement = <></>;
      if (activity.documentExpiration)
      {
        expirationElement = <><span style={{fontSize: "0.9em"}} className="text-muted">Expires: </span><span className="text-muted" style={{fontSize: "0.9em"}}><EditableExpires localExpires={activity.documentExpiration} warnWithColors={true} localActive={true} editingExpires={false} /></span></>;
      }

      return (
        <div key={activity.id}> 
            <div style={{cursor: "pointer"}} className="d-flex" onClick={(e) => {handleClicked(e, activity.practiceId, activity.providerId)}}>
              <div className="flex-grow-1">
                <span style={{fontSize: '0.9em'}}>
                {getTitle(activity)}
                </span>
                <br />
                {documentFilename && 
                  <>
                  <strong>
                    <i style={{ wordBreak: "break-all", fontSize: "0.9em"}}>{documentFilename}</i>
                  </strong>
                  <br />
                  </>
                }
                <span><small className="text-muted">{numberToWordOrdinal(activity.reminderNumber)}: <span style={{fontFamily: "monospace", wordBreak: "break-all"}}>{activity.to}</span></small></span>
                <br />
                <span>{getActivityDateTimeDisplay(activity.sent, false, false, false, true)}</span>
                <span style={{fontSize: '0.9em'}} className="float-end">{expirationElement}</span>
                <br />
              </div>
            </div>
          <hr />
        </div>
      )
    }, this);
  }

return (
    <Card className="flex-fill w-100">
      <Card.Header style={{marginBottom: "-10px"}}>
        <Card.Title className="mb-0"><Badge bg="primary">Recently Sent Reminders</Badge></Card.Title>
      </Card.Header>
      <Card.Body>
        {activityList}
      </Card.Body>
    </Card>
  );
}
export default ReminderFeed;
